module.exports = __webpack_public_path__ + "resources/img/ic_error.d4081ae2c0792cc5f08c8068d4b4ca1f.png";